module.exports = __webpack_public_path__ + "img/description.b36b4336.png";